module.exports = __webpack_public_path__ + "static/img/questionBSel.025dcbde.png";